import { X } from "lucide-react";

/**
 * Banner shown after the "Repair All Shopify Products" action.
 * Displays success with per-product fix list, or an error message.
 */
export default function RepairResultBanner({ repairResult, onDismiss }) {
  if (!repairResult) return null;
  const isSuccess = repairResult.success !== false;
  const fixedCount = repairResult.total_fixed || 0;
  const repairs = repairResult.repairs || [];

  return (
    <div
      className={`mb-4 p-3 rounded border text-xs ${isSuccess ? "bg-green-500/10 border-green-500/20 text-green-400" : "bg-red-500/10 border-red-500/20 text-red-400"}`}
      data-testid="repair-result"
    >
      <div className="flex items-center justify-between">
        <div>
          {isSuccess ? (
            <>
              <span className="font-bold">Repair complete</span> — {fixedCount} product{fixedCount !== 1 ? "s" : ""} fixed
              {repairs.map((r) => (
                <p key={r.id} className="text-[10px] text-white/40 mt-0.5">
                  {r.title}: {(r.fixes || []).join(", ")}
                </p>
              ))}
              {fixedCount === 0 && (
                <p className="text-[10px] text-white/40 mt-0.5">All canvas products already have correct data.</p>
              )}
            </>
          ) : (
            <span className="font-bold">Repair failed: {repairResult.error}</span>
          )}
        </div>
        <button onClick={onDismiss} className="text-white/30 hover:text-white">
          <X size={12} />
        </button>
      </div>
    </div>
  );
}
